import { Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { InfoIcon } from "../assets";
import styles from "./InfoCard.module.css";

export default function InfoCard({ children }: PropsWithChildren) {
	return (
		<div className={styles.card}>
			<InfoIcon className={styles.icon} />
			<Typography className={styles.text}>{children}</Typography>
		</div>
	);
}
